import { render, staticRenderFns } from "./FeaturedCourseCardComponent.vue?vue&type=template&id=35e8bb9c&scoped=true"
import script from "./FeaturedCourseCardComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedCourseCardComponent.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCourseCardComponent.vue?vue&type=style&index=0&id=35e8bb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8bb9c",
  null
  
)

export default component.exports